//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { ILocationService } from 'angular';

import GroupId from '@models/GroupId';
import { SessionVarsService } from '@services/session-vars-service';
import { setQueryParam } from '@utils/urlUtils';

import { crl8 } from 'app/curalate.globals';

class InternalEmployeeBanner {
  public canUserSetInternalView = false;
  public groupId?: GroupId;
  public clientId?: string;
  public groupName?: string;
  public clientName?: string;
  public canUserSetFeatureView?: boolean;
  public featureViewName?: string;
  public isUserElevated?: boolean;
  public elevatedUntil?: string;
  public opsClientUrl?: string;
  public hideGroups?: boolean;

  constructor(
    private readonly sessionVarsService: SessionVarsService,
    private readonly $location: ILocationService,
  ) {
    this.canUserSetInternalView =
      this.sessionVarsService.canUserSetFeatureView();
  }

  public $onInit() {
    if (this.canUserSetInternalView) {
      this.groupId = this.sessionVarsService.getGroup().id;
      this.groupName = this.sessionVarsService.getGroupName();
      this.clientId = this.sessionVarsService.getClientId();
      this.clientName = this.sessionVarsService.getClientName();
      this.canUserSetFeatureView =
        this.sessionVarsService.canUserSetFeatureView();
      this.featureViewName = this.sessionVarsService.getFeatureViewName();
      this.isUserElevated = this.sessionVarsService.isUserElevated();
      this.elevatedUntil = this.sessionVarsService.getElevatedUntil();
      this.opsClientUrl = `${this.sessionVarsService.getBaseUrl(
        'ops_web',
      )}/v1/ops/clients/${this.clientId}`;
      this.hideGroups = this.sessionVarsService.getHideGroups();
    }
  }
  public toggleHideGroups() {
    this.sessionVarsService.setHideGroups(!!this.hideGroups);
  }

  public currentUrlWithClientId() {
    return setQueryParam(this.$location.absUrl(), 'clientId', this.clientId);
  }

  public toggleQueryDevtools() {
    crl8.toggleQueryDevtools?.();
  }
}

angular.module('curalate').component('internalEmployeeBanner', {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  template: require('@legacy-components/internal-employee-banner/internal-employee-banner.html'),
  controller: ['SessionVarsService', '$location', InternalEmployeeBanner],
});
